export class BusinessAnalytics {
    name: string;
    value: number;
}
